import React from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './login.css';
export default function Login() {
    const navigate = useNavigate();
    const [formData, setFormData] = React.useState({
        email: "",
        password: ""
    });
    const handleLoginClick = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_URL}/api/auth/login`, {

                email: formData.email,

                password: formData.password
            });

            console.log('Login successful:', response.data);
            // You can redirect user or show a success message here
            if (response.data.success) {
                //step 1: store the auth token
                localStorage.setItem('authToken', response.data.token);
                localStorage.setItem('userName', response.data.user.name);
                localStorage.setItem('userEmail', response.data.user.email);
                localStorage.setItem('userPhone', response.data.user.phone);
                localStorage.setItem('userRole', response.data.user.role);
                localStorage.setItem('userUsedCodes', JSON.stringify(response.data.user.userCodes));
                //step 2: redirect the user to dashboard/home page
                navigate('/');
            }
        } catch (error) {
  if (error.response) {
    alert("Signup failed: " + error.response.data.message);
  } else {
    console.error("Error:", error.message);
    alert("Something went wrong. Please try again.");
  }
}

    }
    return (
        <>
            <form className='form' action="#">
                <h2>LOG IN</h2>
                <label htmlFor="email">Email</label>
                <input type="email" onChange={(event) => setFormData({ ...formData, email: event.target.value })} name="email" id="email" placeholder='Email' required />
                <label htmlFor="password">Password</label>
                <input type="password" onChange={(event) => setFormData({ ...formData, password: event.target.value })} name="password" id="password" placeholder='Password' required />
                <p>Forgot Password? <button type="button" className="link-button-login" onClick={() => navigate("/Forgot-Password")}>Click here</button></p>
                <button onClick={handleLoginClick}>LOG IN</button>
                <p>Didn't Have Account? <button type="button" className="link-button-login" onClick={() => navigate("/Sign-Up")}> SIGN UP</button></p>
            </form>
        </>
    )
}
